
import   React                          ,
       { useState                       ,
         useEffect                      }  from 'react';

import   classNames                        from 'classnames';

import   styles                            from './AudioSlideshowSheet.module.scss';
import   { MediaGuideState }               from './MediaGuideBanner';

import { useTypedSelector               }  from '../../../store/useTypeSelector';
import { RootState                      }  from '../../../store/generalReducer';

import   Field                             from '../../widget/inputs/Field';
import   FieldImage                        from '../../widget/inputs/FieldImage';
import   FieldSound                        from '../../widget/inputs/FieldSound';
import   Label                             from '../../widget/dataDisplay/labels/Label';
import   CreationIp                     from '../../widget/dataDisplay/labels/CreationIp';
import   TextArea                          from '../../widget/inputs/TextArea';
import   Toggle                            from '../../widget/inputs/Toggle';
import   Trigger                           from '../../widget/actuators/Trigger';
import   WidgetFrame                       from '../../widget/navigation/WidgetFrame';
import   Window                            from '../../widget/windows/window';
import { DownloadProgress               }  from '../../widget/gauge/ProgressBar';

import   MediaSelector                     from './MediaSelector';

import { AudioSlideshow                 ,
         initializedAudioSlideshow      }  from '../../../dataTypes/mediaManagment/audioSlideshow_types';
import { Media                          }  from '../../../dataTypes/mediaManagment/types';

import { testTitle                      ,
         testImageFileToUpload          ,
         testSoundFileToUpload                   }  from '../../../dataTypes/mediaManagment/video_validators';

import { convertDateToString          }  from '../../../dataTypes/timeManagment/utils';


import { updateAudioSlideshow           ,
         createAudioSlideshow }  from '../../../backendServices/mediaManagment/api_audioSlideshow';


import { getImageById                   ,
         downloadImageBlob                }  from '../../../backendServices/mediaManagment/api_image';

import { getSoundById                   ,
         downloadSoundBlob                }  from '../../../backendServices/mediaManagment/api_sound';


import { getMediaList                   }  from '../../../backendServices/mediaManagment/api';


export interface AudioSlideshowSheetProps {
                                            audioSlideshow? : AudioSlideshow;
                                            onCreate?       : ( id: number ) => void;
                                            onEdit?         : ( id: number ) => void;
                                            // Création guidée (MediaSheet) : où en est la saisie.
                                            onGuideState?   : ( state: MediaGuideState ) => void
                                          }

export const AudioSlideshowSheet = ({ audioSlideshow ,
                                      onCreate       ,
                                      onEdit         ,
                                      onGuideState   }: AudioSlideshowSheetProps) => {

  const { authentication } = useTypedSelector((state: RootState) => state.authenticationReducer);
  // Valeur inutilisée, mais l'abonnement est conservé : le retirer changerait
  // la fréquence de rendu du composant.
  useTypedSelector((state: RootState) => state.mediaCategoryReducer);

  const isEditMode = audioSlideshow !== undefined;

  const initialAudioSlideshow: AudioSlideshow = isEditMode ? audioSlideshow! : initializedAudioSlideshow ();

  const [ id                          ] = useState (initialAudioSlideshow.id);
  const [ uuid                        ] = useState (initialAudioSlideshow.uuid);
  const [ active                      , setActive                      ] = useState (initialAudioSlideshow.active);
  const [ creationDate                ] = useState (initialAudioSlideshow.creationDate);
  const [ title                       , setTitle                       ] = useState (initialAudioSlideshow.title);
  const [ description                 , setDescription                 ] = useState (initialAudioSlideshow.description);
  const [ imageDisplayDuration        , setImageDisplayDuration        ] = useState (initialAudioSlideshow.imageDisplayDuration);
  const [ soundPlayingLoopMode        , setSoundPlayingLoopMode        ] = useState (initialAudioSlideshow.soundPlayingLoopMode);
  const [ imageId                     , setImageId                     ] = useState (initialAudioSlideshow.image_id);
  const [ soundId                     , setSoundId                     ] = useState (initialAudioSlideshow.sound_id);

  const [ imageFileToUpload           , setImageFileToUpload           ] = useState<File | null>(null);
  const [ imageSrc                    , setImageSrc                    ] = useState ('');
  const [ imageFileName               , setImageFileName               ] = useState ('');
  const [ imageLoading                , setImageLoading                ] = useState ( false );
  const [ imageProgress               , setImageProgress               ] = useState<DownloadProgress | null>(null);

  const [ soundFileToUpload           , setSoundFileToUpload           ] = useState<File | null>(null);
  const [ soundSrc                    , setSoundSrc                    ] = useState ('');
  const [ soundFileName               , setSoundFileName               ] = useState ('');
  const [ soundLoading                , setSoundLoading                ] = useState ( false );
  const [ soundProgress               , setSoundProgress               ] = useState<DownloadProgress | null>(null);

  const [ titleMessage                , setTitleMessage                ] = useState ( '' );
  const [ descriptionMessage          ] = useState ( '' );
  const [ imageDisplayDurationMessage , setImageDisplayDurationMessage ] = useState ( '' );

  const [ soundFileToUploadMessage    , setSoundFileToUploadMessage    ] = useState ( '' );
  const [ imageFileToUploadMessage    , setImageFileToUploadMessage    ] = useState ( '' );

  const [ numberOfModifiedFields      , setNumberOfModifiedFields      ] = useState (   0   );
  const [ saved                       , setSaved                       ] = useState ( false );
  const [ progress                    , setProgress                    ] = useState (   0   );
  const [ error                       , setError                       ] = useState ( false );
  const [                     , setErrorMsg                    ] = useState (  ''   );
  const [ formError                   , setFormError                   ] = useState ( false );
  const [ saveButtonLock              , setSaveButtonLock              ] = useState ( false )
  const [ cancelAction                , setCancelAction                ] = useState ( false );

  const [ soundMarkedForDeleting      , setSoundMarkedForDeleting      ] = useState ( false );

  useEffect(() => {
    if (onGuideState) onGuideState({ title, categoryChosen: true });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [title]);

  const [ showAudioSelector           , setShowAudioSelector           ] = useState ( false );
  const [ showImageSelector           , setShowImageSelector           ] = useState ( false );

  // Médias (Image/Son existants) proposés dans les sélecteurs ci-dessus, chargés à part de
  // `mediaArray` (store Redux non filtré par owner) pour ne proposer que les médias de l'admin
  // courant, comme le fait la liste principale des médias.
  const [ selectorMediaSet            , setSelectorMediaSet            ] = useState<Media[]>([]);

  useEffect(() => {
    const loadSelectorMediaSet = async () => {
      const result = await getMediaList(['Sound', 'Image'], authentication.admin?.id);

      if (result.code === 1)
       {
        setSelectorMediaSet(result.payload);
       }
    };

    loadSelectorMediaSet();
  }, [authentication.admin?.id]);

  let audioSlideshowSheetId: number = 0

  // Chargement du son avec progression
  const loadSoundBlob = async () => {

    console.log ('loadSoundBlob >>>', soundId)

    if (soundLoading || !soundId) return; // Ne charge que si soundId valide

    setSoundLoading(true);
    setSoundProgress({ loaded: 0, total: 0 });

    try
     {
      console.log ('loadSoundBlob try')

      const getSoundByIdResult = await getSoundById(soundId);

      console.log ('loadSoundBlob', getSoundByIdResult)

      if (getSoundByIdResult.code === 1)
       {
        const completeSoundStruct = await downloadSoundBlob ( getSoundByIdResult.payload                    ,
                                                              (progress) => { setSoundProgress(progress); } );

        console.log ('loadSoundBlob', completeSoundStruct)

        if (completeSoundStruct.objectURL)
              {
               setSoundSrc(completeSoundStruct.objectURL);
               setSoundFileName(completeSoundStruct.soundFile ?? "");
              }
         else {
               console.error("objectURL is undefined");
              }
       }
     }
    catch (error)
     {
      console.error("Erreur lors du chargement du son:", error);
     }
    finally
     {
      setSoundLoading(false);
      setSoundProgress(null);
     }
  };

  // Chargement de l'image avec progression
  const loadImageBlob = async () => {

    console.log ('loadImageBlob >>>', imageId)

    if (imageLoading || !imageId) return; // Ne charge que si imageId valide

    setImageLoading(true);
    setImageProgress({ loaded: 0, total: 0 });

    try
     {
      console.log ('loadImageBlob try')

      const getImageByIdResult = await getImageById(imageId);

      console.log ('loadImageBlob', getImageByIdResult)

      if (getImageByIdResult.code === 1)
       {
        const completeImageStruct = await downloadImageBlob ( getImageByIdResult.payload                    ,
                                                              (progress) => { setImageProgress(progress); } );

        console.log ('loadImageBlob', completeImageStruct)

        if (completeImageStruct.objectURL)
              {
               setImageSrc(completeImageStruct.objectURL);
               setImageFileName(completeImageStruct.imageFile ?? "");
              }
         else {
               console.error("objectURL is undefined");
              }
       }
     }
    catch (error)
     {
      console.error("Erreur lors du chargement de l'image:", error);
     }
    finally
     {
      setImageLoading(false);
      setImageProgress(null);
     }
  };

  // Chargement initial avec délai
  useEffect(() => {
    if (isEditMode) {
      const timers: NodeJS.Timeout[] = [];
      
      if (soundId) {
        timers.push(setTimeout(() => {
          loadSoundBlob();
        }, 100));
      }
      
      if (imageId) {
        timers.push(setTimeout(() => {
          loadImageBlob();
        }, 100));
      }

      return () => timers.forEach(timer => clearTimeout(timer));
    }
  }, []); // Uniquement au montage

  // Rechargement lors du changement de soundId
  useEffect(() => {
    console.log ('useEffect soundId', soundId)
    if (soundId) {
      setSoundSrc(''); // Vide le son précédent pour forcer le rechargement visuel
      loadSoundBlob();
    }
  }, [soundId]);

  // Rechargement lors du changement de imageId
  useEffect(() => {
    console.log ('useEffect imageId', imageId)
    if (imageId) {
      setImageSrc(''); // Vide l'image précédente pour forcer le rechargement visuel
      loadImageBlob();
    }
  }, [imageId]);

  // Nettoyage du blob du son au démontage
  useEffect(() => {
    return () => {
      if (soundSrc && soundSrc.startsWith('blob:')) {
        URL.revokeObjectURL(soundSrc);
      }
    };
  }, [soundSrc]);

  // Nettoyage du blob de l'image au démontage
  useEffect(() => {
    return () => {
      if (imageSrc && imageSrc.startsWith('blob:')) {
        URL.revokeObjectURL(imageSrc);
      }
    };
  }, [imageSrc]);

  ///// Gestion de la vérification avant sauvegarde

  const check = (): boolean => {
    
    let test = true;

    if ( imageDisplayDuration === '' )
          {
           setImageDisplayDurationMessage ("Il manque la durée d'affichage") 
           test = test && false;
          }
     else {
           const regex = /^([01]\d|2[0-3]):([0-5]\d):([0-5]\d)$/;
           
           if ( regex.test(imageDisplayDuration) === false )
                 {
                  setImageDisplayDurationMessage ("Le timecode doit respecter le format HH:MM:SS") 
                  test = test && false;
                 }
            else {
                  setImageDisplayDurationMessage ("") 
                  test = test && true;
                 }
          }

    const mess = testTitle ( title )
    
    setTitleMessage ( mess )
    
    test = test && ( mess === '' )

    if (imageSrc === '' && imageFileToUpload === null) 
          {
           setImageFileToUploadMessage("Il manque l'image à afficher");
           test = test && false;
          } 
     else {
           setImageFileToUploadMessage("");
           test = test && true;
          }

    return test    
  }

  ///// Gestion de la sauvegarde

  const save = async () => {

    const titleErrorMessageBis             = testTitle             (title);
    const imageFileToUploadErrorMessageBis = testImageFileToUpload (imageFileToUpload === null ? undefined : imageFileToUpload);
 
    const test = titleErrorMessageBis === "" &&
                 ( ( imageSrc === '' && imageFileToUploadErrorMessageBis === "" ) || imageSrc !== '');

    if ( numberOfModifiedFields > 0 && test )
          {
           const result = isEditMode ?

                     await updateAudioSlideshow ( id                                 ,
                                                  active                             ,
                                                  title                              ,
                                                  description                        ,
                                                  imageDisplayDuration               ,
                                                  soundPlayingLoopMode               ,
                                                  imageFileToUpload                  ,
												  imageId                            ,
                                                  soundFileToUpload                  ,
                                                  soundMarkedForDeleting             ,
												  soundId                            ,
                                                  setProgress                        ,
                                                  authentication.admin?.id           )

                     :

                     await createAudioSlideshow ( active                             ,
                                                  title                              ,
                                                  description                        ,
                                                  imageDisplayDuration               ,
                                                  soundPlayingLoopMode               ,
                                                  imageFileToUpload                  ,
												  imageId                            ,
                                                  soundFileToUpload                  ,
												  soundId                            ,
                                                  setProgress                        ,
                                                  authentication.admin?.id           )

                if ( result.code === 1 )
                 {
                  audioSlideshowSheetId = isEditMode ? id : result.payload
                  setSaved    (true); // On arrête d'afficher la progression
                  setProgress (0)
                  setError    (false);
                  setNumberOfModifiedFields (0);
                 }
				  
           else if ( result.code < 1)
                 {
                  setSaved    (true); // On arrête d'afficher la progression
                  setProgress (0)
                  setError    (true);
                  setErrorMsg (result.comment);
                 }
          }
     else {
           setSaveButtonLock (false)
          }
  }

  ///// Gestion des modifications sur les widgets et les zones de saisies

  const handleActiveChange = ( newState: boolean , id?: number | undefined) => {

    const fieldIsAlreadyModified = active !== initialAudioSlideshow.active;
    setActive (newState)

    if ( newState === initialAudioSlideshow.active &&  fieldIsAlreadyModified) { setNumberOfModifiedFields(prev => Math.max(0, prev - 1)); }
    if ( newState !== initialAudioSlideshow.active && !fieldIsAlreadyModified) { setNumberOfModifiedFields(prev => prev + 1);              }
  }

  const handleTitleChange = (e: React.ChangeEvent<HTMLInputElement>) => {

    const fieldIsAlreadyModified = title !== initialAudioSlideshow.title

                      setTitle  ( e.target.value )
    setTitleMessage ( testTitle ( e.target.value ) )

    if ( e.target.value === initialAudioSlideshow.title &&  fieldIsAlreadyModified ) { setNumberOfModifiedFields ( numberOfModifiedFields - 1 ) }
    if ( e.target.value !== initialAudioSlideshow.title && !fieldIsAlreadyModified ) { setNumberOfModifiedFields ( numberOfModifiedFields + 1 ) }
  }

  const handleDescriptionChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {

    const fieldIsAlreadyModified = description !== initialAudioSlideshow.description

                            setDescription  ( e.target.value )

    if ( e.target.value === initialAudioSlideshow.description &&  fieldIsAlreadyModified ) { setNumberOfModifiedFields ( numberOfModifiedFields - 1 ) }
    if ( e.target.value !== initialAudioSlideshow.description && !fieldIsAlreadyModified ) { setNumberOfModifiedFields ( numberOfModifiedFields + 1 ) }
  }

  const handleImageDisplayDurationChange = (e: React.ChangeEvent<HTMLInputElement>) => {

    const fieldIsAlreadyModified = imageDisplayDuration !== initialAudioSlideshow.imageDisplayDuration

    setImageDisplayDuration  ( e.target.value )

    if ( e.target.value === '' )
          {
           setImageDisplayDurationMessage ("Il manque la durée d'affichage") 
          }
     else {
           const regex = /^([01]\d|2[0-3]):([0-5]\d):([0-5]\d)$/;
           
           if ( regex.test(e.target.value) === false )
                 {
                  setImageDisplayDurationMessage ("Le timecode doit respecter le format HH:MM:SS") 
                 }
            else {
                  setImageDisplayDurationMessage ("") 
                    }
           }

    if ( e.target.value === initialAudioSlideshow.imageDisplayDuration &&  fieldIsAlreadyModified ) { setNumberOfModifiedFields ( numberOfModifiedFields - 1 ) }
    if ( e.target.value !== initialAudioSlideshow.imageDisplayDuration && !fieldIsAlreadyModified ) { setNumberOfModifiedFields ( numberOfModifiedFields + 1 ) }
  }

  const handleSoundPlayingLoopModeChange = (newMode: boolean) => {

    const fieldIsAlreadyModified = soundPlayingLoopMode !== initialAudioSlideshow.soundPlayingLoopMode

    setSoundPlayingLoopMode  ( newMode )

    if ( newMode === initialAudioSlideshow.soundPlayingLoopMode &&  fieldIsAlreadyModified ) { setNumberOfModifiedFields ( numberOfModifiedFields - 1 ) }
    if ( newMode !== initialAudioSlideshow.soundPlayingLoopMode && !fieldIsAlreadyModified ) { setNumberOfModifiedFields ( numberOfModifiedFields + 1 ) }
  }


  const handleImageFileToUploadChange = (event: React.ChangeEvent<HTMLInputElement>) => {

    if (event && event.target && event.target.files) {
      setImageFileToUpload(event.target.files[0]);
      setImageFileToUploadMessage(testImageFileToUpload(event.target.files[0]));
      setNumberOfModifiedFields(prev => prev + 1);
    }
  };

  const handleSoundFileToUploadChange = (event: React.ChangeEvent<HTMLInputElement>) => {

    if (event && event.target && event.target.files) {
      setSoundFileToUpload(event.target.files[0]);
      setSoundFileToUploadMessage(testSoundFileToUpload(event.target.files[0]));
      setNumberOfModifiedFields(prev => prev + 1);
      setSoundMarkedForDeleting (false)
    }
  };

  const handleSoundDelete = () => {
      setSoundFileToUpload(null);
      setSoundFileToUploadMessage('');
      setNumberOfModifiedFields(prev => prev + 1);
      setSoundMarkedForDeleting (true)
  }


  const handleSaveActionButton = () => {

    if ( check() )
          {
           if ( !saveButtonLock )
                 {
                  setSaveButtonLock (true)
                  save ()
                 }
            else {
                  console.log ("LOCK")
                 }
          }
     else {
           setFormError (true)
          }
  }

  const handleCreationAckButton = () => {
	  
    setSaved (false)
    setProgress (0)
    setSaveButtonLock (false)

    if ( isEditMode )
          {
           if ( onEdit )
            {
             onEdit ( audioSlideshowSheetId )
            }
          }
     else {
           if ( onCreate )
            {
             onCreate ( audioSlideshowSheetId )
            }
          }
  }

  const handleErrorAckButton = () => {

    setSaved (false)
    setProgress (0)
    setSaveButtonLock (false)
    window.scroll(0, 0);
  }

  const handleFormErrorAckButton = () => {

     setFormError (false)
  }

  ///// Gestion du bouton [ANNULER] qui permet de sortir de la saisie de la fiche
  
  const handleCancelActionButton = () => {

    setCancelAction (true)
  }

  const handleCancelButton_cancelAction = () => {

    setCancelAction (false)
    setSaved (false)
    setProgress (0)
    setSaveButtonLock (false)
    window.scroll(0, 0);
  }

  const handleValidButton_cancelAction = () => {

    setCancelAction (false)

    if ( isEditMode )
          {
           if ( onEdit )
            {
             onEdit ( 0 )
            }
          }
     else {
           if ( onCreate )
            {
             onCreate ( 0 )
            }
          }
  }

  ///// Gestion de la fenêtre de sélection d'une image

  const handleImageSelectorShow = () =>{

	setShowImageSelector (true)
  }

  const handleImageSelectorCancel = () =>{

	setShowImageSelector (false)
  }
  
  const handleImageSelection = (id: number) => {

    console.log ('handleImageSelection', id, initialAudioSlideshow.image_id)

    setShowImageSelector(false);
	
    const fieldIsAlreadyModified = imageId !== initialAudioSlideshow.image_id;
	setImageId (id)

    if ( id === initialAudioSlideshow.image_id &&  fieldIsAlreadyModified) { setNumberOfModifiedFields(prev => Math.max(0, prev - 1)); }
    if ( id !== initialAudioSlideshow.image_id && !fieldIsAlreadyModified) { setNumberOfModifiedFields(prev => prev + 1);              }

	
  }

  ///// Gestion de la fenêtre de sélection d'un son

  const handleAudioSelectorShow = () =>{
	  
	setShowAudioSelector (true)
  }

  const handleAudioSelectorCancel = () =>{
	  
	setShowAudioSelector (false)
  }

  const handleAudioSelection = (id: number) => {

    console.log ('handleAudioSelection', id, initialAudioSlideshow.sound_id)

    setShowAudioSelector(false);
	
    const fieldIsAlreadyModified = soundId !== initialAudioSlideshow.sound_id;
	setSoundId (id)

    if ( id === initialAudioSlideshow.sound_id &&  fieldIsAlreadyModified) { setNumberOfModifiedFields(prev => Math.max(0, prev - 1)); }
    if ( id !== initialAudioSlideshow.sound_id && !fieldIsAlreadyModified) { setNumberOfModifiedFields(prev => prev + 1);              }
  }


  return (

           <div className={classNames(styles.root)}>

			 {
		      showAudioSelector &&
              <MediaSelector onCancel        = {handleAudioSelectorCancel}
			                 onSelect        = {handleAudioSelection}
                             mediaSet        = {selectorMediaSet}
                             originalFilter  = {['Sound']}
                             mediaTypeNames  = {['Sound']} />
			 }

			 {
		      showImageSelector &&
              <MediaSelector onCancel        = {handleImageSelectorCancel}
			                 onSelect        = {handleImageSelection}
			                 mediaSet        = {selectorMediaSet}
			                 originalFilter  = {['Image']}
			                 mediaTypeNames  = {['Image']} />
			 }

             {
              formError &&
              <Window message                 = {<>La fiche contient des erreurs</>}
                      messageType             = "information"
                      onClickOnValidateButton = {handleFormErrorAckButton}   />
             }

             {
              !saved && (progress > 0) &&
              <Window message     = {<>Les éléments de la fiche sont en cours d'upload<br/>{`${ (progress * 0.95).toFixed(0) }%`} effectués</>}
                      messageType = "information"   />
             }

             {
              saved && error &&
              <Window message                 = {<>Une erreur est survenue lors de la création de la fiche</>}
                      messageType             = "information"
                      onClickOnValidateButton = {handleErrorAckButton}   />
             }

             {
              saved && !error &&
              <Window message                 = {isEditMode ? <>Fiche modifiée</> : <>Fiche créée</>}
                      messageType             = "information"
                      onClickOnValidateButton = {handleCreationAckButton}
                      validButtonText         = "Ok" />
             }
             
             {
              cancelAction &&
              <Window message                 = {<>Etes-vous sûr de vouloir annuler vos saisies ?</>}
                      messageType             = "question"
                      onClickOnCancelButton   = {handleCancelButton_cancelAction}
                      onClickOnValidateButton = {handleValidButton_cancelAction}   />
             }

              <div className={classNames(styles.contain)}>

                {/* Même présentation que la fiche vidéo : Id / Uuid / Date / IP dans un
                    bandeau à part, au-dessus du bloc des éléments du média. */}
                {
                 isEditMode &&
                 <div className={classNames(styles.topBar)}>
                   <WidgetFrame name               = "Id :"
                                error              = ""
                                labelTextPosition  = "right"
                                labelBlockPosition = "left" >
                     <p className = {classNames(styles.text)}>{id}</p>
                   </WidgetFrame>
                   <WidgetFrame name               = "Uuid :"
                                error              = ""
                                labelTextPosition  = "right"
                                labelBlockPosition = "left" >
                     <p className = {classNames(styles.text)}>{uuid}</p>
                   </WidgetFrame>
                   <Label value = {`Date de création : ${convertDateToString(creationDate, 'dd/MM/yyyy HH:mm')}`} />
                   <CreationIp ipAddress = {initialAudioSlideshow.creationIpAddress} />
                 </div>
                }

                <div className={classNames(styles.form)}>

                  <div className={classNames(styles.active)}>
                    <WidgetFrame name               = "Actif :"
                                 labelTextPosition  = "right"
                                 labelBlockPosition = "left"
                                 classNameGrid      = {classNames(styles.grid_frame)} >
                      <Toggle checked  = {active}
                              onChange = {handleActiveChange}
                              form     = "switch" />
                    </WidgetFrame>
                  </div>

                  <div className={classNames(styles.left)}>
                    <div className={classNames(styles.title)} data-guide="title">
                      <WidgetFrame name               = "Titre :"
                                   error              = {titleMessage}
                                   labelTextPosition  = "right"
                                   labelBlockPosition = "left"
                                   classNameGrid      = {classNames(styles.grid_frame)} >
                          <Field  type          = "text"
                                  placeholder   = ""
                                  value         = {title}
                                  onChange      = {handleTitleChange} />
                      </WidgetFrame>
                    </div>

                    <div className={classNames(styles.description)}>
                      <WidgetFrame name               = "Description :"
                                   error              = {descriptionMessage}
                                   labelTextPosition  = "right"
                                   labelBlockPosition = "left"
                                   classNameGrid      = {classNames(styles.grid_frame)} >
                        <TextArea placeholder   = ""
                                  value         = {description}
                                  onChange      = {handleDescriptionChange} />
                      </WidgetFrame>
                    </div>
                  </div>

                  <div className={classNames(styles.imageDisplayDuration)}>
                    <WidgetFrame name               = "Durée :"
                                 error              = {imageDisplayDurationMessage}
                                     labelTextPosition  = "right"
                                 labelBlockPosition = "left"
                                 classNameGrid      = {classNames(styles.grid_frame2)} >
                        <Field  type          = "text"
                                placeholder   = "HH:MM:SS"
                                width         = "150px"
                                value         = {imageDisplayDuration}
                                onChange      = {handleImageDisplayDurationChange} />
                    </WidgetFrame>
                  </div>

                  <div className={classNames(styles.imageToDisplay)}>
                    <WidgetFrame name               = "Image :"
                                 error              = {imageFileToUploadMessage}
                                 labelTextPosition  = "right"
                                 labelBlockPosition = "left"
                                 classNameGrid      = {classNames(styles.grid_frame2)} >
                      <FieldImage placeholder   = ""
                                  value         = {imageFileName}
                                  mediaURL      = {imageSrc}            
                                  onChange      = {handleImageFileToUploadChange}
                                  onShowLibrary = {handleImageSelectorShow} 
								  library       = {true}
                                  isLoading     = {imageLoading}
                                  loadProgress  = {imageProgress} />
                    </WidgetFrame>
                  </div>

                  <div className={classNames(styles.soundToPlay)}>
                    <WidgetFrame name               = "Son :"
                                 error              = {soundFileToUploadMessage}
                                 labelTextPosition  = "right"
                                 labelBlockPosition = "left"
                                 classNameGrid      = {classNames(styles.grid_frame2)} > 
                      <FieldSound placeholder   = ""
                                  value         = {soundFileName}
                                  mediaURL      = {soundSrc}            
                                  onChange      = {handleSoundFileToUploadChange}
                                  onDelete      = {handleSoundDelete} 
							      onShowLibrary = {handleAudioSelectorShow}
								  library       = {true}
                                  isLoading     = {soundLoading}
                                  loadProgress  = {soundProgress} />
                    </WidgetFrame>
                  </div>
                    
                  <div className={classNames(styles.loopMode)}>
                    <WidgetFrame name               = "Loop :"
                                 labelTextPosition  = "right"
                                 labelBlockPosition = "left"
                                 classNameGrid      = {classNames(styles.grid_frame2)} >
                      <Toggle checked  = {soundPlayingLoopMode}
                              onChange = {handleSoundPlayingLoopModeChange}
                              form     = "switch" />
                    </WidgetFrame>
                  </div>
				  
                  <div className={classNames(styles.buttons)}>
                    <div className={classNames(styles.bloc)}>
                      <Trigger name    = "Annuler" 
					           onClick = {handleCancelActionButton} 
							   variant = "tailwind2" />
                      &nbsp;&nbsp;&nbsp;&nbsp;
                      <Trigger {...(isEditMode && numberOfModifiedFields > 0 ? { buttonBackgroundColor: "#DC2626", buttonBackgroundHoverColor: "#B91C1C", buttonForegroundColor: "#fff", buttonForegroundHoverColor: "#fff" } : {})} name    = {isEditMode?`Enregistrer${numberOfModifiedFields > 0 ? ` (${numberOfModifiedFields})` : ""}`:"Créer"} 
					           onClick = {handleSaveActionButton} 
							   variant = "tailwind2" />
                      &nbsp;&nbsp;
                      {
                       numberOfModifiedFields > 0 && isEditMode &&
                       ( <p className={styles.modBadge} > {numberOfModifiedFields} modification{numberOfModifiedFields > 1 ? "s" : ""} </p> )
                      }
                    </div>
                  </div>

                </div>

              </div>

           </div>

         );


};


export default AudioSlideshowSheet;
